import { createComputed, createNested, OnSignal } from 'dreamstate';

import { ELiveSignal, TInteractionSessionReadySignalEvent } from '../../signals';
import { AbstractFirebaseManager, IFirebaseContext } from './AbstractFirebaseManager';
import { initializeInteractionToolsConnection } from './AbstractFirebaseManager.interactionActions';

export type IInteractionFirebaseContext = IFirebaseContext;

export class InteractionFirebaseManager extends AbstractFirebaseManager<IInteractionFirebaseContext> {
  public override context: IFirebaseContext = {
    isFirebaseReady: false,
    isComposerReady: false,
    isInteractionReady: false,
    isStreamHealthReady: false,
    isDisposed: false,
    interactionCredentials: null,
    composerCredentials: null,
    streamHealthCredentials: null,
    interactionConnection: createNested({
      isConnected: false,
      user: null,
    }),
    composerConnection: createNested({
      isConnected: false,
      user: null,
    }),
    streamHealthConnection: createNested({
      isConnected: false,
      user: null,
    }),
    connectionStatuses: createComputed(({ interactionConnection }: Partial<IFirebaseContext>) => ({
      isInteractionConnected: Boolean(
        interactionConnection?.isConnected && interactionConnection?.user !== null,
      ),
    })),
  };

  /**
   * Check whether manager is expecting firebase is connected.
   */
  public isConnected(): boolean {
    const { interactionConnection } = this.context;

    return interactionConnection.isConnected && interactionConnection.user !== null;
  }

  @OnSignal(ELiveSignal.INTERACTION_SESSION_READY)
  protected async onInteractionSessionReady(
    signal: TInteractionSessionReadySignalEvent,
  ): Promise<void> {
    this.log.info('Initializing firebase connection on session init');
    await initializeInteractionToolsConnection(this, signal);
  }
}
